import api from './client';

interface Envelope<T> {
  success: boolean;
  data: T;
}

interface DeleteAccountResponse {
  deleted: boolean;
}

/**
 * Permanently delete the current user's account.
 * Backend cascades: cancel Stripe subscription -> delete profile -> delete auth user.
 * Caller is responsible for signing out and routing away on success.
 */
export async function deleteAccount(): Promise<DeleteAccountResponse> {
  const res = await api.post<Envelope<DeleteAccountResponse>>(
    '/api/account/delete'
  );
  return res.data;
}
